export const configs = {
  courtConnectBaseUrl: window["config"].courtConnectBaseUrl,
  proxyKey: window["config"].proxyKey,
  session: window["config"].session,
  loggedIn: window["config"].loggedIn,
  apiBaseUrl: window["config"].apiBaseUrl,
  basePath: window["config"].BASE_PATH
};
